import React from 'react';
import { View } from 'react-native';
import { GET_MACHINE_DETAIL_MOBILE, SUBSCRIBE_TO_MACHINE_MOBILE, MODIFY_MACHINE } from '../../../common/graphql/machine';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import MachineDetail from './MachineDetail';

const MachineDetailView = ({ machineId }) => {
	const styles = useThemedStyles(createStyles);

	return (
		<View style={styles.container}>
			<MachineDetail
				id={machineId}
				query={GET_MACHINE_DETAIL_MOBILE}
				subscription={SUBSCRIBE_TO_MACHINE_MOBILE}
				modifyMutation={MODIFY_MACHINE}
				s3Path="images/places/"
			/>
		</View>
	);
};

const createStyles = ({ ui: { colors } }) => ({
	container: {
		backgroundColor: colors.canvas,
		flex: 1,
	},
});

export default MachineDetailView;
